import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({
  providedIn: "root",
})
export class ReadNotificationWebService {
  constructor(private handler: BaseHandler) {}

  execute(id: number, token: string): Observable<void> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.post)
      .setUrl(ApiUrls.READ_NOTIFICATION_ENDPOINT(id))
      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.handler.execute(parameters);
  }
}
